import React from 'react';

import App from './App';
import { createRoot } from 'react-dom/client';

export const renderApp = (rootElement: HTMLElement) => {
  const root = createRoot(rootElement);
  root.render(<App />);
};
